import React, { useState, useEffect } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';

import { AiOutlinePlus, AiFillEdit, AiFillDelete, AiFillPicture, AiOutlineClose, AiOutlineUndo, AiOutlineDelete} from 'react-icons/ai'
import { BsCardChecklist } from 'react-icons/bs'
import { GoVerified ,GoUnverified } from "react-icons/go";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { SiMinutemailer } from "react-icons/si";

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useHistory } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import Badge from 'react-bootstrap/Badge';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { confirm } from "react-confirm-box";
import { defaultConf } from "../config/DefaultConf";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import 'bootstrap/dist/css/bootstrap.min.css';

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () => console.log());

  return (
    <Card.Header
      onClick={decoratedOnClick}
    >
      {children}
    </Card.Header>
  );
}

function News() {
  const history = useHistory()
  const [dataList, setDataList] = useState([])
  const [fileList, setFileList] = useState([])
  const [fullscreen, setFullscreen] = useState(true);

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [pageFile, setPageFile] = useState(1);
  const [limitFile, setLimitFile] = useState(15);
  const [pagesFile, setPagesFile] = useState(0);
  const [rowsFile, setRowsFile] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const newDate = new Date(Date.now() + (1*24*60*60*1000));
  const filePath = defaultConf.uploadUrl;
  const [modalShow, setModalShow] = React.useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  
  useEffect(() => {
    getDataList()        
  }, [page, keyword]);

  const getDataList = async () => {
    await Api().get(`contents/list/news?filter=${keyword}&fields=title,descriptions,contents&page=${page}&limit=${limit}`)
    .then((response) => response)
    .then((data) => {
      const listData = data.data;
      setDataList(listData.docs);
      setPage(listData.page);
      setPages(listData.totalPages);
      setRows(listData.totalDocs);
    })
    .catch((err) => {
    })
  }
  
  const getFileList = async (pageNum=pageFile, limitNum=limitFile) => {
    await Api().get(`files?page=${pageNum}&limit=${limitNum}`)
    .then((response) => response)
    .then((responseFiles) => {
      console.log(responseFiles)
      const listFiles = responseFiles.data;
      setFileList(listFiles.docs);
      setPageFile(listFiles.page);
      setPagesFile(listFiles.totalPages);
      setRowsFile(listFiles.totalDocs);
      setModalShow(true)
    })
    .catch((err) => {
    })
  }

  const changePage = ({ selected }) => {
    setDataList([])
    setPage(selected+1);
    // getDataList();
  }

  const changePageFile = ({ selected }) => {
    console.log(selected)
    setFileList([])
    setPageFile(selected+1);
    getFileList(selected+1);
  }

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setKeyword(query);
  }

  const handleDelete = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    
    const confirm_action = await confirm("Anda yakin ingin menghapus data ini secara PERMANENT?");
    if (confirm_action) {
      await Api().delete(`contents/${id}`)
      .then((response) => response)
      .then((res) => {
        if( res.status === 200 ){
          getDataList()
        }
      })
      .catch((err) => {
          
      });
    }
  }

  const handleSoftDelete = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const payload = {
      isDeleted: true,
    };
    const confirm_action = await confirm("Anda yakin ingin menghapus data ini?");
    if (confirm_action) {
      await Api().patch(`contents/delete/soft/${id}`, payload)
      .then((response) => response)
      .then((res) => {
        if( res.status === 200 ){
          getDataList()
        }
      })
      .catch((err) => {
          
      });
    }
  }

  const handleRestore = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    const payload = {
      isDeleted: false,
    };
    const confirm_action = await confirm("Anda yakin ingin mengembalikan data ini?");
    if (confirm_action) {
      await Api().patch(`contents/delete/soft/${id}`, payload)
      .then((response) => response)
      .then((res) => {
        if( res.status === 200 ){
          getDataList()
        }
      })
      .catch((err) => {
          
      });
    }
  }

  function blockedTimes(date, days) {
    if( days > 0 )
    {
      var netDate = new Date();
    }
    else{
      var netDate = new Date();
    }
    
    netDate.setDate(netDate.getDate() + days);
    return moment(netDate).format();
  }
  
  const handleSetImage = async (e) => {
    // e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value

    const payload = {
      type: "Content",
      banner: id
    };

    await Api().put(`files/cover/${selectedProject}`, payload)
    .then((response) => response)
    .then((res) => {
      console.log(res)
      if( res.status === 200 ){
        window.location.reload()
      }
    })
    .catch((err) => {
        
    });
  }
  
  const handleDeleteImage = async (e) => {
    // e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value

    const payload = {
      type: "Content",
      banner: null
    };

    await Api().put(`files/cover/${id}`, payload)
    .then((response) => response)
    .then((res) => {
      console.log(res)
      if( res.status === 200 ){
        window.location.reload()
      }
    })
    .catch((err) => {
        
    });
  }

  const handleOpenFiles = async (e) => {
    e.preventDefault();
    const id = e.target.attributes.getNamedItem("data-id").value
    setSelectedProject(id)
    setFullscreen(true)
    getFileList()
  }

  const handleCloseModal = () => {
    setModalShow(false)
    setPageFile(1);
    setPagesFile(0);
    setRowsFile(0);
  }

  const decodeHtml = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.documentElement.textContent;
  }

  return (
    <>
      <div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
        <DefaultLayout />
        {/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
        <main>
          <div className="content-header">
            <Container fluid>
              <Row className="">
                  <Col sm={4}>
                  <h1 className="m-0">News</h1>
                  </Col>
                  <Col sm={2}>
                      { checkMenu('addnews') &&
                          <Link to="addnews"><Button variant="outline-primary" className="btn-upload"><AiOutlinePlus /> Add News</Button></Link>
                      }
                  </Col>
                  <Col sm={3}>
                  <Form className="d-flex" onSubmit={searchData}>
                      <Form.Control
                      type="search"
                      placeholder="Search"
                      className="me-2 input-search"
                      aria-label="Search"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      />
                      <Button type="submit" className="btn-search"><FiSearch /></Button>
                  </Form>
                  </Col>
                  <Col sm={3}>
                  <div className="date-time float-sm-right">
                      { moment().format('dddd, DD MMMM YYYY') }
                  </div>
                  </Col>
              </Row>
            </Container>
          </div>
                
          <div className="content">
            <Container fluid>
              <Row>
                <Col lg={12} style={{padding: '0'}}>
                  <Table striped hover size="sm">
                    <thead className='thead'>
                      <tr>
                        <th style={{ width: '5%'}} className="text-center">No</th>
                        <th style={{ width: '15%'}} className="text-left">Thumbnails/Banner</th>
                        <th style={{ width: '10%'}} className="text-left">Page</th>
                        <th style={{ width: '10%'}} className="text-left">Section</th>
                        <th style={{ width: '15%'}} className="text-left">Title</th>
                        <th style={{ width: '35%'}} className="text-left">Contents</th>
                        <th style={{ width: '5%'}} className="text-left">Is Deleted?</th>
                        <th style={{ width: '5%'}} className="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        dataList.map((item, i) => (
                          <tr key={i}>
                            <td className="text-center">
                                {page === 1 ?
                                    i+1 : ( limit * (page-1) ) + (i+1)
                                }
                            </td>
                            <td className="text-left">
                              {item.banner === null || item.banner === '' || typeof item.banner === 'undefined' ?
                                <Link to="#" onClick={handleOpenFiles} data-id={item._id}>Set Image/Banner</Link>
                                :
                                <>
                                  <img src={filePath + item.banner.uploadFile} width="200"/>
                                  <Link to="#" onClick={handleOpenFiles} data-id={item._id}>Change Image/Banner</Link><br />
                                  <Link to="#" onClick={handleDeleteImage} data-id={item._id}>Delete Image/Banner</Link>
                                </>
                              }
                            </td>
                            <td className="text-left">{item.contentPage}</td>
                            <td className="text-left">{item.section}</td>
                            <td className="text-left">{item.title}</td>
                            <td className="text-left">
                              Descriptions : <br />
                              <p>{decodeHtml(item.descriptions)}</p>
                              <Accordion bg="light" key="Light" text="white" className="mb-2" border="danger">
                                <Card bg="light" key="Light" text="white" className="mb-2" border="danger">
                                  <CustomToggle eventKey="0">
                                    Contents
                                  </CustomToggle>
                                  <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <Card.Text>
                                          {decodeHtml(item.contents)}
                                        </Card.Text>
                                      </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              </Accordion>
                            </td>
                            <td className="text-center">{item.isDeleted ? "Yes" : "No"}</td>
                            <td className="text-left">
                              <NavDropdown title="Action" className='' id="basic-nav-dropdown">
                                { item.banner === null || item.banner === '' || typeof item.banner === 'undefined' ?
                                  <NavDropdown.Item href="#" onClick={handleOpenFiles} data-id={item._id}><AiFillPicture /> Set Image/Banner</NavDropdown.Item>
                                  :
                                  <>
                                    <NavDropdown.Item href="#" onClick={handleOpenFiles} data-id={item._id}><AiFillPicture /> Change Image/Banner</NavDropdown.Item>
                                    <NavDropdown.Item href="#" onClick={handleDeleteImage} data-id={item._id}><AiFillDelete /> Delete Image/Banner</NavDropdown.Item>
                                  </>
                                }
                                { checkMenu('editnews') && 
                                  <NavDropdown.Item href={ "editnews/" + item._id }><AiFillEdit /> Change</NavDropdown.Item>
                                }
                                { checkMenu('softdeletenews') && 
                                  !item.isDeleted &&
                                    <NavDropdown.Item href="#" onClick={handleSoftDelete} data-id={item._id}><AiOutlineDelete /> Soft Delete</NavDropdown.Item>
                                }
                                { checkMenu('restorenews') && 
                                  item.isDeleted &&
                                    <NavDropdown.Item href="#" onClick={handleRestore} data-id={item._id}><AiOutlineUndo /> Restore</NavDropdown.Item>
                                }
                                { checkMenu('deletenews') &&
                                    <NavDropdown.Item href="#" onClick={handleDelete} data-id={item._id}><AiFillDelete /> Delete</NavDropdown.Item>
                                }
                              </NavDropdown>
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </Table>
                  <Card className="content-list">
                    <Card.Footer>
                      <Row>
                        <Col lg={3}>
                          <p>Total Data: {rows} Page: {rows ? page : 0} of {pages}</p>
                        </Col>
                        <Col lg={9}>
                          <nav
                            className="pagination float-sm-right"
                            key={rows}
                            role="navigation"
                            aria-label="pagination"
                          >
                            <ReactPaginate
                              previousLabel={"< Prev"}
                              nextLabel={"Next >"}
                              pageCount={pages}
                              onPageChange={changePage}
                              containerClassName={"pagination-list pagination"}
                              pageLinkClassName={"pagination-link page-link"}
                              previousLinkClassName={"pagination-previous page-link"}
                              nextLinkClassName={"pagination-next page-link"}
                              activeLinkClassName={"pagination-link is-current"}
                              disabledLinkClassName={"pagination-link is-disabled"}
                              activeClassName={"active"}
                              pageClassName={"page-item"}
                            />
                          </nav>
                        </Col>
                      </Row>
                    </Card.Footer>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </main>
      </div>
      <Footer />

      <Modal 
        show={modalShow} 
        fullscreen={fullscreen} 
        onHide={handleCloseModal}
        dialogClassName="modal-full-custom"
        scrollable={fullscreen}
      >
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>
            Set Image/Banner Content
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Row xs={5} md={5} lg={5} className="g-2">
              {
                fileList.map((item, i) => (
                  <Col key={i}>
                    <Card>
                      <Card.Img variant="top" src={filePath + item.uploadFile} />
                      
                      <Card.Body>
                        <Button variant="primary" data-id={item._id}  onClick={handleSetImage}>Choose This</Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              }
            </Row>
          </Container>
          
        </Modal.Body>
        <Modal.Footer>
          <Container fluid>
            <Row>
              <Col lg={3} md={4}>
                <p>Total Data: {rowsFile} Page: {rowsFile ? pageFile : 0} of {pagesFile}</p>
              </Col>
              <Col lg={9} md={8}>
                <nav
                  className="pagination float-sm-right"
                  key={rowsFile}
                  role="navigation"
                  aria-label="pagination"
                >
                  <ReactPaginate
                    previousLabel={"< Prev"}
                    nextLabel={"Next >"}
                    pageCount={pagesFile}
                    onPageChange={changePageFile}
                    containerClassName={"pagination-list pagination"}
                    pageLinkClassName={"pagination-link page-link"}
                    previousLinkClassName={"pagination-previous page-link"}
                    nextLinkClassName={"pagination-next page-link"}
                    activeLinkClassName={"pagination-link is-current"}
                    disabledLinkClassName={"pagination-link is-disabled"}
                    activeClassName={"active"}
                    pageClassName={"page-item"}
                  />
                </nav>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default News
